class RiseBenefits extends HTMLElement {
  connectedCallback() {
    this.marquee = this.querySelector('[data-rise-benefits-marquee]');
    this.track = this.querySelector('[data-rise-benefits-track]');
    if (!this.marquee || !this.track) return;

    this.#build();
    window.addEventListener('resize', this.#onResize, { passive: true });
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.#onResize);
  }

  #onResize = () => {
    window.clearTimeout(this._resizeTimer);
    this._resizeTimer = window.setTimeout(() => this.#build(), 150);
  };

  #build() {
    const baseHTML = this.track.dataset.baseHtml || this.track.innerHTML;
    this.track.dataset.baseHtml = baseHTML;
    this.track.innerHTML = baseHTML;

    // Remove previous duplicates
    this.marquee.querySelectorAll('[data-rise-benefits-clone]').forEach((el) => el.remove());

    let loops = 0;
    while (this.track.scrollWidth < window.innerWidth * 1.5 && loops < 12) {
      this.track.insertAdjacentHTML('beforeend', baseHTML);
      loops += 1;
    }

    const clone = this.track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.setAttribute('data-rise-benefits-clone', '');
    this.marquee.appendChild(clone);
  }
}

if (!customElements.get('rise-benefits-component')) {
  customElements.define('rise-benefits-component', RiseBenefits);
}
